import { render } from "./AllowLogin.vue?vue&type=template&id=34df857b"
import script from "./AllowLogin.vue?vue&type=script&lang=js"
export * from "./AllowLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__